'use client'

import PropTypes from 'prop-types'
import { useEffect, useState, useCallback } from 'react'
import MUITypography from '@mui/material/Typography'
import { useTimeRecordingStore } from '@repo/store/useTimeRecordingStore'

export const TimeRecordingTimeDisplay = ({
  isTimer = false,
  timerIsPlaying = false,
  entry = {},
  sx = {},
  variant = 'subtitle1',
  syncTime = false
}) => {
  const [renderTrigger, setRenderTrigger] = useState(0)
  const { renderTimerTime, renderPostingTime, updateActiveTimerSeconds } = useTimeRecordingStore()
  const [intervalVar, setIntervalVar] = useState(null)

  const tick = useCallback(() => {
    setRenderTrigger(renderTrigger + 1)
    updateActiveTimerSeconds()
  }, [updateActiveTimerSeconds, renderTrigger])

  useEffect(() => {
    if (!isTimer || !syncTime || !timerIsPlaying) return

    // trigger a re-render every x seconds to keep the timer display in sync
    const interval = setInterval(tick, 1000)
    setIntervalVar(interval)

    // Clear the interval
    return () => clearInterval(interval)
  }, [isTimer, syncTime, timerIsPlaying, updateActiveTimerSeconds, tick])

  useEffect(() => {
    if (!timerIsPlaying && intervalVar) {
      clearInterval(intervalVar)
    }
  }, [timerIsPlaying, intervalVar])

  return (
    <MUITypography
      variant={variant}
      data-testid="TimeRecordingTimeDisplay"
      data-timer-tick={renderTrigger}
      sx={{
        color: 'text.secondary',
        mb: 0,
        mr: 1,
        minWidth: '60px',
        textAlign: 'right',
        pointerEvents: 'none',
        textTransform: 'none',
        ...sx
      }}
    >
      {isTimer ? renderTimerTime({ timerIsPlaying, timer: entry }) : renderPostingTime({ posting: entry })}
    </MUITypography>
  )
}

TimeRecordingTimeDisplay.propTypes = {
  isTimer: PropTypes.bool,
  timerIsPlaying: PropTypes.bool,
  entry: PropTypes.object,
  sx: PropTypes.object,
  variant: PropTypes.string,
  syncTime: PropTypes.bool
}
